function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#000"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.55,
  cy: 5.455,
  rx: 5.55,
  ry: 5.455
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.95 0H34a3 3 0 013 3v7.91H12.95V0zM11.1 16.363h14.8v3.636H11.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1 16.363h14.8v3.636H11.1z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 12.727h37v3.636H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 12.727h37v3.636H0z"
})));
function SvgCtUploadScanParametersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 20,
    viewBox: "0 0 37 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg width='37' height='20' viewBox='0 0 37 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg id='CT Icon'%3e %3cellipse id='Ellipse 1253' cx='5.55' cy='5.45455' rx='5.55' ry='5.45455' fill='black'/%3e %3cpath id='Rectangle 11520' d='M12.95 0H34C35.6569 0 37 1.34315 37 3V10.9091H12.95V0Z' fill='black'/%3e %3cg id='Rectangle 11521'%3e %3crect x='11.1' y='16.3635' width='14.8' height='3.63636' fill='black'/%3e %3crect x='11.1' y='16.3635' width='14.8' height='3.63636' fill='black'/%3e %3c/g%3e %3cg id='Rectangle 11522'%3e %3crect y='12.7273' width='37' height='3.63636' fill='black'/%3e %3crect y='12.7273' width='37' height='3.63636' fill='black'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgCtUploadScanParametersIcon as ReactComponent };